import React from 'react';
import './HomePage.css';
import Navigation from '../components/Navigation';
import Home from '../components/Home';
import Featured from '../components/Featured';
import Events from '../components/Events';
import Workshops from '../components/Workshops';
import Gallery from '../components/Gallery';
import Team from '../components/Team';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="homepage">
      <Navigation />
      <Home />
      <Featured />
      <Events />
      <Workshops />
      <Gallery />
      <Team />
      <About />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;